import React, { Component } from 'react';
import { FormGroup, Label, Input } from "reactstrap";
import FetchCall, { getAreaNames, saveAnaLytics } from '../../API/FetchCall';
import Autosuggest from 'react-autosuggest';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, Row, Col, ModalHeader } from 'reactstrap';

import {
  BASE_URL, GOOGLE_CAPTCHA_SITE_KEY, SCREEN_SIZE, GOOGLE_LOGIN_CLIENT_ID,
  LINKEDIN_CLIENT, FACBEOOK_APP_ID, LINKEDIN_SECRET, ADMIN_URL
} from '../../constant';

class AllVerticalStep1 extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            pageinfo:this.props.pageinfo,
            fromblog:this.props.pageinfo.fromblog,
            suggestions: [],
            location:"",
            showleadpop:false
        };
        this.handleChangeCity = this.handleChangeCity.bind(this);
    }

    handleSubmit(){

    }

  componentDidMount(){


    let isMobile = false;
    if (SCREEN_SIZE <= 767) {
      isMobile = true;
    }


  }

  handleChangeCity(event) {
    
    const { name, value } = event.target;

    this.setState({
      [name]: value
    });

    if(value=='others'){
      this.setState({isothers:true})
    }else{
      this.setState({isothers:false})
    }

  }  

    /* suggestion*/

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {

    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      city: this.state.city,
      keyword:val
    });
    getAreaNames(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, index, method }) => {
      console.log('ping... ', suggestion)

      this.setState({
          latitude: suggestion.latitude,
          longtitude: suggestion.longtitude,
          isSuggested:true
      });


  }


  handleClickScroll = () => {

    const element = document.getElementById("toptrending_section");
    //element.scrollIntoView(); 
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onAutoSuggestChange = (event, { newValue, method }) => {
    this.setState({
      location: newValue,
      isSuggested:false
    });
  };

  handleclick = (e) => {

    $(".floating-menu").toggleClass("hidden");
    $(".floating-menu-close-btn").toggleClass("hidden");

  }

  closeleadpop= () => {
    this.setState({
      showleadpop:false
    });
  }  
    
    render() {

 let isMobile = false;
    if (SCREEN_SIZE <= 767) {
      isMobile = true;
    }

    const inputPropsD = {
      value: this.state.location,
      onChange: this.onAutoSuggestChange,
      name: 'location',
      className: 'form-control'
    };
    const {value, suggestions, city, isothers, localities, fromblog, fromvertical, subcat2} = this.state;
        return '';
     /*

        return (
        
            <React.Fragment>
            <div class="col-xs-12 col-md-12 no-padding">
            <div class="preloadstep ">
            
            {this.props.pageinfo.fromblog=='tuitionblogs' && (
                      <>           
                      <p>Tailor your needs and generate Top Tuition centers for you</p>
                      </>
            )}
            {this.props.pageinfo.fromblog=='schoolblogs' && (
                      <>           
                      <p>Tailor your needs and generate Top Schools for you </p>
                      </>
            )}            

            {this.props.pageinfo.fromvertical=='boarding-schools' && (
                      <>           
                      <p>Tailor your needs and generate Top Boarding Schools for you</p>
                      </>
            )}
            
            {this.props.pageinfo.fromvertical=='private-schools' && (
                      <>           
                      <p>Tailor your needs and generate Top Private Schools for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='public-schools' && (
                      <>           
                      <p>Tailor your needs and generate Top Public Schools for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='international-schools' && (
                      <>           
                      <p>Tailor your needs and generate Top International Schools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='school-special-needs' && (
                      <>           
                      <p>Tailor your needs and generate Top Special Needs Schools for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='alternative-schools' && (
                      <>           
                      <p>Tailor your needs and generate Top Alternative Schools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='maths' && (
                      <>           
                      <p>Tailor your needs and generate Top Mathematics Tuition for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='science' && (
                      <>           
                      <p>Tailor your needs and generate Top Science Tuition for you</p>
                      </>
            )} 
            {this.props.pageinfo.fromvertical=='economics' && (
                      <>           
                      <p>Tailor your needs and generate Top Economics Tuition for you</p>
                      </>
            )} 
            {this.props.pageinfo.fromvertical=='business-studies' && (
                      <>           
                      <p>Tailor your needs and generate Top Business Studies centers for you</p>
                      </>
            )} 
            {this.props.pageinfo.fromvertical=='languages' && (
                      <>           
                      <p>Tailor your needs and generate Top Languages Tuition for you</p>
                      </>
            )} 
            {this.props.pageinfo.fromvertical=='social-science' && (
                      <>           
                      <p>Tailor your needs and generate Top Social Science Tuition for you</p>
                      </>
            )} 
           

            {this.props.pageinfo.fromvertical=='preschool' && (
                      <>           
                      <p>Tailor your needs and generate Top Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='montessori' && (
                      <>           
                      <p>Tailor your needs and generate Top Montessori Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='kindergarten' && (
                      <>           
                      <p>Tailor your needs and generate Top Kindergarten Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='play-group' && (
                      <>           
                      <p>Tailor your needs and generate Top Play group Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='special-needs' && (
                      <>           
                      <p>Tailor your needs and generate Top Special Needs Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='day-care-or-creche' && (
                      <>           
                      <p>Tailor your needs and generate Top Creche Preschools for you</p>
                      </>
            )}

            {this.props.pageinfo.fromvertical=='tuitions' && (
                      <>           
                      <p>Tailor your needs and generate Top Tuitions Centers for you</p>
                      </>
            )}
             {this.props.pageinfo.fromvertical=='school' && (
                      <>           
                      <p>Tailor your needs and generate Top Schools for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='arts' && (
                      <>           
                      <p>Tailor your needs and generate Top Art Classes for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='music' && (
                      <>           
                      <p>Tailor your needs and generate Top Music Classes for you</p>
                      </>
            )}
            {(this.props.pageinfo.fromvertical=='dance' || this.props.pageinfo.fromvertical=='dance-and-theatre') && (
                      <>           
                      <p>Tailor your needs and generate Top Dance Classes for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='skills' && (
                      <>           
                      <p>Tailor your needs and generate Top Skill Enrichment Classes for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='hobbies' && (
                      <>           
                      <p>Tailor your needs and generate Top Hobbies and Passion Enrich Classes for you</p>
                      </>
            )}
            {this.props.pageinfo.fromvertical=='sports' && (
                      <>           
                      <p>Tailor your needs and generate Top Sports Classes for you</p>
                      </>
            )}

                      <div class="finalstepform">
                      <div class="row">
                        <div class="col-md-5 col-sm-12">
                        <Label for="location">My City</Label>
                        <select name="city"  class="form-control form-control-sm"
                          id="city" onChange={this.handleChangeCity}>
                          <option value="">Choose your city</option>
                          <option value="bengaluru">Bengaluru</option>
                          <option value="chennai">Chennai</option>
                          <option value="others">Others</option>
                        </select>
                        </div>
                       
                        <div class="col-md-5 col-sm-12">
                        {this.state.city!='others' && 
                        <> 
                        <Label for="location">My Locality</Label>
                        <Autosuggest 
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        onSuggestionSelected={this.onSuggestionSelected}
                        inputProps={inputPropsD} 
                        />
                        </> 

                        }
                        </div>
                        <div class="col-md-2 col-sm-12">
                            <div class="btnaligned">
                            {(this.props.pageinfo.fromvertical=='school' || this.props.pageinfo.fromblog=='schoolblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(
                                
                                this.props.pageinfo.fromvertical=='boarding-schools' ||
                                this.props.pageinfo.fromvertical=='private-schools' ||
                                this.props.pageinfo.fromvertical=='public-schools' ||
                                this.props.pageinfo.fromvertical=='international-schools' ||
                                this.props.pageinfo.fromvertical=='school-special-needs' ||
                                this.props.pageinfo.fromvertical=='alternative-schools') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='tuitions' || this.props.pageinfo.fromblog=='tuitionblogs') && (    
                            
                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='maths' ||
                              this.props.pageinfo.fromvertical=='science' ||
                              this.props.pageinfo.fromvertical=='economics' ||
                              this.props.pageinfo.fromvertical=='business-studies' ||
                              this.props.pageinfo.fromvertical=='languages' ||
                              this.props.pageinfo.fromvertical=='social-science') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}
                        
                            {(this.props.pageinfo.fromvertical=='preschool' ||
                              this.props.pageinfo.fromvertical=='montessori' ||
                              this.props.pageinfo.fromvertical=='kindergarten' ||
                              this.props.pageinfo.fromvertical=='play-group' ||
                              this.props.pageinfo.fromvertical=='special-needs' ||
                              this.props.pageinfo.fromvertical=='day-care-or-creche') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-preschools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}



                            {(this.props.pageinfo.fromvertical=='sports' || this.props.pageinfo.fromblog=='sportsblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-sports-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='music' || this.props.pageinfo.fromblog=='musicblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-music-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )} 
                            {(this.props.pageinfo.fromvertical=='dance' || this.props.pageinfo.fromvertical=='dance-and-theatre' || this.props.pageinfo.fromblog=='danceblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-dance-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='arts'  || this.props.pageinfo.fromblog=='artblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-arts-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='skills'  || this.props.pageinfo.fromblog=='skillblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-skill-enrichment-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='hobbies'  || this.props.pageinfo.fromblog=='hobbiesblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-hobby-passion-enriching-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            </div>
                        </div>
                    </div>   
                    </div>
                
          </div>
          </div>

          <nav class="floating-menu hidden" id="sideMenuContainer">
            

       

            {this.props.pageinfo.fromvertical=='school' && (
                      <>           
                      <a href="/best-schools-near-me" id="lead" class="menuitem">Generate my shortlist</a>
                      </>
            )}
            
             {(this.props.pageinfo.fromvertical=='maths' ||
                              this.props.pageinfo.fromvertical=='science' ||
                              this.props.pageinfo.fromvertical=='economics' ||
                              this.props.pageinfo.fromvertical=='business-studies' ||
                              this.props.pageinfo.fromvertical=='languages' ||
                              this.props.pageinfo.fromvertical=='social-science') && (
                      <>           
                      <a href="/best-tuitions-near-me" id="lead" class="menuitem">Generate my shortlist</a>
                      </>
            )} 

            {this.props.pageinfo.fromvertical=='sports' && (

                      <>      
                      <a href="/best-sports-classes-near-me" id="lead" class="menuitem">Generate my shortlist</a>
                      </>
            )} 


            <a  id="totoptrending" class="menuitem goto_trending">Top Trending</a>
            <a  id="toarticles" class="menuitem goto_articles">Articles</a>
          </nav>

          <div class="floating-menu-btn-listing" onClick={() => this.handleclick()}><i class="fa fa-bars" aria-hidden="true"></i></div>

           <Modal className='d-flex new-lead-pop mobileonly' isOpen={this.state.showleadpop} size='xl'>
            
           <ModalBody className='p-0'>
            <button
              className='lead-close-btn'
              data-dismiss='modal'
              aria-label='Close'
              onClick={this.closeleadpop}
            >
              close
            </button>
            <div className=''>
              <Row className='m-5 text-center'>
                <Col sm={{ size: 12 }} className=''>
                   
                   <div class="finalstepform">
                      <div class="row">
                        <div class="col-md-5 col-sm-12 text-left">
                        <Label for="location">My City</Label>
                        <select name="city"  class="form-control form-control-sm"
                          id="city" onChange={this.handleChangeCity}>
                          <option value="">Choose your city</option>
                          <option value="bengaluru">Bengaluru</option>
                          <option value="chennai">Chennai</option>
                          <option value="others">Others</option>
                        </select>
                        </div>
                       
                        <div class="col-md-5 col-sm-12 text-left">
                        {this.state.city!='others' && 
                        <> 
                        <Label for="location">My Locality</Label>
                        <Autosuggest 
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        onSuggestionSelected={this.onSuggestionSelected}
                        inputProps={inputPropsD} 
                        />
                        </> 

                        }
                        </div>
                        <div class="col-md-2 col-sm-12">
                            <div class="btnalignedright">
                            {(this.props.pageinfo.fromvertical=='school' || this.props.pageinfo.fromblog=='schoolblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(
                                
                                this.props.pageinfo.fromvertical=='boarding-schools' ||
                                this.props.pageinfo.fromvertical=='private-schools' ||
                                this.props.pageinfo.fromvertical=='public-schools' ||
                                this.props.pageinfo.fromvertical=='international-schools' ||
                                this.props.pageinfo.fromvertical=='school-special-needs' ||
                                this.props.pageinfo.fromvertical=='alternative-schools') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='tuitions' || this.props.pageinfo.fromblog=='tuitionblogs') && (    
                            
                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='maths' ||
                              this.props.pageinfo.fromvertical=='science' ||
                              this.props.pageinfo.fromvertical=='economics' ||
                              this.props.pageinfo.fromvertical=='business-studies' ||
                              this.props.pageinfo.fromvertical=='languages' ||
                              this.props.pageinfo.fromvertical=='social-science') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}
                        
                            {(this.props.pageinfo.fromvertical=='preschool' ||
                              this.props.pageinfo.fromvertical=='montessori' ||
                              this.props.pageinfo.fromvertical=='kindergarten' ||
                              this.props.pageinfo.fromvertical=='play-group' ||
                              this.props.pageinfo.fromvertical=='special-needs' ||
                              this.props.pageinfo.fromvertical=='day-care-or-creche') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-preschools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}



                             {(this.props.pageinfo.fromvertical=='sports' || this.props.pageinfo.fromblog=='sportsblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-sports-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='music' || this.props.pageinfo.fromblog=='musicblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-music-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}
                            {(this.props.pageinfo.fromvertical=='dance' || this.props.pageinfo.fromvertical=='dance-and-theatre' || this.props.pageinfo.fromblog=='danceblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-dance-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='arts'  || this.props.pageinfo.fromblog=='artblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-arts-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='skills'  || this.props.pageinfo.fromblog=='skillblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-skill-enrichment-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='hobbies'  || this.props.pageinfo.fromblog=='hobbiesblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-hobby-passion-enriching-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.location,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            </div>
                        </div>
                    </div>   
                    </div>


                </Col>
              </Row>
            </div>
          </ModalBody>

          </Modal>


          </React.Fragment >
            
        );*/
    }
}
export default AllVerticalStep1;